<div class="modal-header">
  <h4 class="modal-title">
    {{ 'dyeConnection.dialog.title' | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="pb-3">{{ 'dyeConnection.dialog.label' | translate }}</div>
    <div class="d-flex flex-column">
      <div class="d-flex flex-row">
        @for ( dyeColor of connectionDyeColors(); track dyeColor.id ) {
          <div class="radio-option d-flex flex-grow-1 flex-column dye-color selectable"
               [class.selected-color]="dyeColor.color === selectedColor?.color"
               (click)="onSelectedColorChanged(dyeColor)">
            @if (typeof dyeColor.value === 'string') {
            <app-color-dot class="mx-1 my-2" [colorCode]="dyeColor.value" displayBorder=true />
            } @else {
            <app-color-dot class="mx-1 my-2" [color]="dyeColor.color" displayBorder=true />
            }
            <span>{{dyeColor.label | translate}}</span>
          </div>
        }
      </div>
      <div class="d-flex justify-content-center">
        <div class="radio-option d-flex flex-column dye-color no-color selectable px-1"
             [class.selected-color]="connectionNoDyeColor.color === selectedColor?.color"
             (click)="onSelectedColorChanged(connectionNoDyeColor)">
          <app-color-dot class="mx-1 my-2" [colorCode]="connectionNoDyeColor.value" displayBorder=true />
          <span>{{connectionNoDyeColor.label | translate}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel"
          type="button"
          (click)="cancel()">{{'global.label.cancel' | translate}}
  </button>
  <button id="customarticle_save" class="btn btn-primary btn-forward"
          type="submit"
          (click)="apply()">{{'global.label.apply' | translate}}
  </button>
</div>
